<template>
  <div class="fail-box">
    <img
      class="fail-icon"
      src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-07-13/d837d770ee6aae4af10ba7e2d3550c40.png"
      alt="Fail Icon"
    />
    <div class="title">
      {{
        lostData.deleted
          ? "该答题不存在，可能被出题人删除"
          : "该答题活动已被删除"
      }}
    </div>
    <div class="contact" v-if="lostData.deleted">
      <button class="contact-btn" @click="toQuesList">我知道了</button>
      <button
        class="contact-btn position-r"
        style="margin-left: 24px;"
        @click="toCreate"
      >
        去创建一个
        <WxLink v-if="isWeixin && isMobile" :wxPath="createWxpath" />
      </button>
    </div>
    <template v-else>
      <div
        class="desc position-r"
        v-if="!lostData.is_owner"
        @click="toHomePage()"
      >
        该答题已被出题人删除，具体的活动规则请联系出题人
        <button style="color: #1890ff; display: initial; font-size: 14px;">
          {{ lostData.name }}
        </button>
        咨询，或进入出题人主页-订阅，有新的答题活动将推送提醒
        <WxLink
          v-if="isWeixin && isMobile"
          :wxPath="ownerWxPath + lostData.unionid"
        />
      </div>
      <div class="desc position-r" v-else>
        答题活动被删除后，参与人无法再进入作答请重新
        <span style="color: #1890ff;" @click="toCreate">
          创建答题活动
        </span>
        分享给参与人作答。
        <WxLink v-if="isWeixin && isMobile" :wxPath="createWxpath" />
      </div>
      <div
        class="contact position-r"
        v-if="!lostData.is_owner"
        @click="toHomePage()"
      >
        <button class="contact-btn">
          联系出题人
        </button>
        <button class="contact-btn r">出题人主页</button>
        <WxLink
          v-if="isWeixin && isMobile"
          :wxPath="ownerWxPath + lostData.unionid"
        />
      </div>
      <div class="welfare-box" @click="toRecovery" v-if="lostData.is_owner">
        <div class="welfare">
          <div class="left">
            <div class="left-vip">该答题已过期，放入回收站中</div>
            <div class="vip-desc">前往回收站可恢复近期删除的内容</div>
          </div>
          <div class="welfare-right">
            立即前往
            <img
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220729/787a041ab28350c97a8b6577e1fcf3a1.png"
              class="welfare-right-icon"
              alt="Right Icon"
            />
          </div>
        </div>
      </div>
    </template>

    <div
      style="padding: 30px 0 15px; border-radius: 2px;"
      v-if="(lostData && !lostData.enterprise_vip) || lostData.deleted"
    >
      <Ad v-if="!isInApp" :isWeixin="isWeixin" :isMobile="isMobile" />
    </div>
  </div>
</template>

<script>
import Ad from "../../components/common/ad.vue";
import { getWxUrl } from "@/utils/common";
import WxLink from "@/components/wxLink.vue";

export default {
  props: {
    lostData: {
      type: Object,
      value: {}
    },
    isMobile: {
      type: Boolean,
      value: false
    },
    isInApp: {
      type: Boolean,
      value: false
    },
    isWeixin: {
      type: Boolean,
      value: false
    }
  },
  data() {
    return {
      createWxpath: "/pages/createdefault/createdefault",
      ownerWxPath: "/pages/homepage/homepage?unionid="
    };
  },
  components: { Ad, WxLink },
  methods: {
    toQuesList() {
      this.$router.push({
        name: "questionList"
      });
      // 跳转到题目列表的逻辑
    },
    async toCreate() {
      // 跳转到创建答题的逻辑
      if (!this.isInApp && !this.isMobile) {
        window.location.href = "https://xiaoxiaodati.com/home?clear=1";
        return;
      }
      if (this.isMobile) {
        let url = await getWxUrl();
        window.location.href = url;
      } else {
        this.$router.push({ name: "createHelp" });
      }
    },
    toHomePage() {
      this.$emit("toHomePage", this.lostData.unionid);
    },
    jumpOwner() {
      // 跳转到出题人主页的逻辑
    },
    toRecovery() {
      this.$router.push({ name: "questionList" });
    }
  }
};
</script>

<style scoped>
/* 在这里添加你的 CSS 样式 */
.fail-box {
  max-width: 500px;
  position: relative;
  max-width: 500px;
  min-width: 320px;
  font-size: 14px;
  margin: 0 auto;
  transition: none;
}
.fail-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 15px;
  display: block;
}
.title {
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  font-weight: 350;
  color: #262626;
}
.desc {
  font-size: 14px;
  font-weight: 350;
  line-height: 20px;
  text-align: center;
  margin: 15px 22px 0;
  color: #999999;
}
.contact {
  margin: 40px 7px 0;
  display: flex;
  justify-content: center;
}
.contact-btn {
  width: 158px;
  height: 35px;
  display: inline-block;
  background: #1890ff;
  color: #ffffff;
  border-radius: 2px;
  font-size: 15px;
  text-align: center;
  line-height: 35px;
}
.contact-btn.r {
  margin-left: 20px;
}
.welfare-box {
  margin: 0 15px;
}

.welfare .left-vip {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 5px;
}
.vip-desc {
  font-size: 10px;
  line-height: 15px;
}
.welfare {
  height: 55px;
  background-size: cover;
  /* margin: 0 25rpx; */
  padding: 10px;
  box-sizing: border-box;
  height: 62px;
  color: #ffffff;
  border-radius: 4px;
  margin: 20px auto 0;
  background: #313238;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.welfare .left-icon {
  width: 15px;
  height: 17px;
  margin-right: 5px;
}
.welfare-right {
  background: linear-gradient(90deg, #d8ae7a -9.8%, #f5cea5 100%);
  border-radius: 150px;
  text-align: center;
  line-height: 22px;
  font-size: 14px;
  color: #313238;
  padding: 2px 10px;
  display: inline-flex;
  align-items: center;
}
.welfare-right-icon {
  width: 7px;
  height: 12px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/detailFail.vue